import { request } from '@/api/service'
export function jsapiTicket (data) {
    return request({
      url: 'corp_wx/js-sdk/config_params/',
      method: 'post',
      data
    })
}